export const getMenuItems = () => {
  return [
    { key: "1", label: "Gerenciar Períodos" },
    { key: "2", label: "Editar" },
    { key: "3", label: "Andamentos" },
  ];
};
